import it from '../../translation/it_IT'

export default {
  // i18nConfiguration
  i18n: {
    locales: [
      {
        code: 'it',
        iso: 'it-IT',
      },
    ],
    defaultLocale: 'it',
    vueI18n: {
      fallbackLocale: 'it',
      messages: {
        it,
      },
    },
    pages: {
      'categories/inspirations': {
        it: '/ispirazioni',
      },
      'categories/gifts': {
        it: '/regali',
      },
      'categories/occasions': {
        it: '/occasioni',
      },
      'categories/tutorials-and-advices': {
        it: '/tutorial-e-consigli',
      },
      'categories/home-furnishing': {
        it: '/arredo-casa',
      },
      'editorial-staff/index': {
        it: '/redazione',
      },
      'editorial-staff/_author': {
        it: '/redazione/:author?',
      },
    },
  },
  /* 
    Categories Configuration
    @order: [] è l'array delle chiavi delle categorie e rappresenta l'ordine con cui verranno visualizzate le categorie dove richieste
    list{
        @key è la chiave della categoria. Per convenzione chiamata come il folder dentro page.
        {
          @slug è lo slug della categoria inserito in categorie su Wordpress
          @view è la view di nuxt e corrisponde al name utilizzato nei nuxt-link
        }
    }
  */
  pages: {
    // leggere README.md
    list: [
      {
        key: 'index', // Home per comodità la trattiamo come una categoria
        wpUri: '/?page_id=105',
        // wpUri: '/'
      },
      {
        key: 'inspirations',
        wpUri: '?page_id=29',
        // wpUri: '/inspirations/',
      },
      {
        key: 'gifts',
        wpUri: '?page_id=29',
        // wpUri: '/gifts/',
      },
      {
        key: 'occasions',
        wpUri: '?page_id=33',
        // wpUri: '/occasions/',
      },
      {
        key: 'tutorials-and-advices',
        wpUri: '?page_id=35',
        // wpUri: '/tutorials-and-advices/',
      },
      {
        key: 'home-furnishing',
        wpUri: '?page_id=37',
        // wpUri: '/home-furnishing/',
      },
      {
        key: 'editorial-staff',
        wpUri: '/redazione/',
      },
    ],
  },
  categories: {
    // leggere README.md
    list: [
      {
        key: 'inspirations',
        wpSlug: 'inspirations',
        view: 'categories-inspirations',
        wpCategoryId: 2,
      },
      {
        key: 'gifts',
        wpSlug: 'gifts',
        view: 'categories-gifts',
        wpCategoryId: 3,
      },
      {
        key: 'occasions',
        wpSlug: 'occasions',
        view: 'categories-occasions',
        wpCategoryId: 4,
      },
      {
        key: 'tutorials-and-advices',
        wpSlug: 'tutorials-and-advices',
        view: 'categories-tutorials-and-advices',
        wpCategoryId: 5,
      },
      {
        key: 'home-furnishing',
        wpSlug: 'home-furnishing',
        view: 'categories-home-furnishing',
        wpCategoryId: 6,
      },
      {
        key: 'highlights',
        wpSlug: 'highlights',
        view: null,
        wpCategoryId: 8,
      },
    ],
  },
  giftaWebsite: 'https://www.gifta.it/',
  navigation: {
    primary: {
      order: [
        'inspirations',
        'gifts',
        'occasions',
        'tutorials-and-advices',
        'home-furnishing',
      ],
    },
    // Categorie che vengono filtrate da eventuali elenchi (es. la lista delle categorie a cui appartiene un post)
    exclude: ['highlights'],
  },
  social: [
    {
      key: 'facebook',
      url: 'https://www.facebook.com/gifta.it/',
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/gifta.it/',
    },
  ],
  terms: [
    {
      key: 'privacy-policy',
      url: 'https://www.gifta.it/privacy-policy/',
    },
    {
      key: 'cookie-policy',
      url: 'https://www.gifta.it/cookie/',
    },
    {
      key: 'informazioni-legali',
      url: 'https://www.gifta.it/informazioni-legali/',
    },
  ],
  pixaLinks: [
    {
      key: 'books-magazines',
      url: 'https://www.pixartprinting.it/stampa-riviste-cataloghi-libri/',
    },
    {
      key: 'business-cards',
      url: 'https://www.pixartprinting.it/biglietti-da-visita/',
    },
    {
      key: 'flyers',
      url: 'https://www.pixartprinting.it/piccolo-formato/stampa-volantini-flyer/',
    },
  ],
  shopLinks: [
    {
      label: 'Regali personalizzati',
      url: 'https://www.gifta.it/regali-personalizzati/',
    },
    {
      label: 'Stampa su tela',
      url: 'https://www.gifta.it/stampa-su-tela/',
    },
    {
      label: 'Quadri personalizzati',
      url: 'https://www.gifta.it/stampa-su-tela/quadri-canvas-personalizzati/',
    },
    {
      label: 'Decorazioni da parete',
      url: 'https://www.gifta.it/decorazioni-da-parete/',
    },
    {
      label: 'Fotoregali',
      url: 'https://www.gifta.it/fotoregali/',
    },
    {
      label: 'Cuscini personalizzati',
      url: 'https://www.gifta.it/fotoregali/cuscini-personalizzati/',
    },
    {
      label: 'Tazze personalizzate',
      url: 'https://www.gifta.it/fotoregali/tazze-personalizzate/',
    },
    {
      label: 'Borse personalizzate',
      url: 'https://www.gifta.it/fotoregali/borse-shopper-personalizzate/',
    },
    {
      label: 'Magliette personalizzate',
      url: 'https://www.gifta.it/magliette-personalizzate/',
    },
    {
      label: 'Fotolibri',
      url: 'https://www.gifta.it/fotolibri/',
    },
    {
      label: 'Calendari personalizzati',
      url: 'https://www.gifta.it/calendari-personalizzati/',
    },
    {
      label: 'Idee regalo',
      url: 'https://www.gifta.it/idee-regalo/',
    },
  ],
  nuxtConfiguration: {
    head: {
      script: [
        {
          src: 'https://21fd768e7ea04855a8a850bd8ab542cf.js.ubembed.com',
          async: true,
        },
      ],
    },
  },
}
